var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchWithSingleSelect',{attrs:{"disabled":_vm.disabled,"displayValue":"","label":_vm.label,"loadingOptions":_vm.loading,"name":"Manager","options":_vm.options,"totalOptions":_vm.options.length,"value":_vm.manager},on:{"filter":_vm.search,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }